import { collectTrackData } from '@/utils/Tracker/tracker';
import { collect } from '@/analytics';

const EVENT = {
  NAME: 'gaEvent',
  CATEGORY: {
    STUDIO: 'HostGator Studio',
  },
  ACTION: {
    CREATE_SITE_TOP: 'Clique no Botão - Criar site com IA',
    CREATE_SITE_BOTTOM: 'Clique no Botão - Criar site com IA',
    LOGO_CREATOR: 'Clique na Funcionalidade',
    REMOVE_BACKGROUND: 'Clique na Funcionalidade',
    BRAND_KIT: 'Clique na Funcionalidade',
    PROJECTS: 'Clique no Botão - Projetos',
    OPEN_EDITOR: 'Clique no Botão - Abrir editor ( + )',
    OPEN_TEMPLATE: 'Clique no Template',
    BANNER_PRO: 'Clique no Botão - Experimente o Pro',
    SHOW_MORE_TEMPLATES: 'Clique no Botão - Mostrar mais templates',
    CREATE_LOGO: 'Clique no Botão - Criar logo',
    MODAL_LOGO_BUTTON_BACK: 'Clique no Botão - Voltar',
    GO_TO_STUDIO: 'Clique no Botão - Ir para o Studio',
    DOWNLOAD_LOGO: 'Clique no Botão - Baixar',
    EDIT_LOGO: 'Clique no Botão - Editar',
    GENERATE_MORE_OPTIONS: 'Clique no Botão - Gerar mais opções',
    CREATE_LOGO_MANUALLY: 'Clique no Botão - Criar logo manualmente',
    FEATURE_NO_CREDITS_CTA: 'Clique na Funcionalidade - Saldo insuficiente',
    STUDIO_FREE_CTA: 'Clique na Funcionalidade - Studio Grátis',
  },
  LABEL: {
    CREATE_SITE_TOP: 'Dashboard - Crie site com IA - Superior',
    CREATE_SITE_BOTTOM: 'Dashboard - Crie site com IA - Inferior',
    LOGO_CREATOR: 'Dashboard - Criador de logo com IA',
    REMOVE_BACKGROUND: 'Dashboard - Remover fundo com IA',
    BRAND_KIT: 'Dashboard - Kit de marca',
    PROJECTS: 'Dashboard - Projetos',
    OPEN_EDITOR: 'Dashboard - Abrir editor',
    OPEN_TEMPLATE: 'Dashboard - Abrir template',
    BANNER_PRO: 'Dashboard - Listagem de formatos de templates',
    SHOW_MORE_TEMPLATES: 'Dashboard - Listagem de formatos de templates',
    CREATE_LOGO: 'Criador de logo com IA - Sobre sua marca',
    MODAL_LOGO_BUTTON_BACK: 'Criador de logo com IA - Sobre sua marca',
    GO_TO_STUDIO: 'Criador de logo com IA - Sobre sua marca',
    DOWNLOAD_LOGO: 'Logo criado',
    EDIT_LOGO: 'Logo criado',
    GENERATE_MORE_OPTIONS: 'Logo criado',
    CREATE_LOGO_MANUALLY: 'Logo criado',
    LOGO_BUILDER_NO_CREDITS_CTA: 'Dashboard - Criador de logo com IA - Saldo insuficiente',
    BACKGROUND_REMOVER_NO_CREDITS_CTA: 'Dashboard - Remover fundo com IA - Saldo insuficiente',
    BACKGROUND_REMOVER_STUDIO_FREE_CTA: 'Dashboard - Remover fundo com IA - Studio Grátis',
    BRAND_KIT_NO_CREDITS_CTA: 'Dashboard - Kit de marca - Saldo insuficiente',
    BRAND_KIT_STUDIO_FREE_CTA: 'Dashboard - Kit de marca - Studio Grátis',
  },
};

const events = {
  createSiteTopClick: {
    campaign: EVENT.CATEGORY.STUDIO,
    action: EVENT.ACTION.CREATE_SITE_TOP,
    label: EVENT.LABEL.CREATE_SITE_TOP,
  },
  createSiteBottomClick: {
    campaign: EVENT.CATEGORY.STUDIO,
    action: EVENT.ACTION.CREATE_SITE_BOTTOM,
    label: EVENT.LABEL.CREATE_SITE_BOTTOM,
  },
  logoCreatorClick: {
    campaign: EVENT.CATEGORY.STUDIO,
    action: EVENT.ACTION.LOGO_CREATOR,
    label: EVENT.LABEL.LOGO_CREATOR,
  },
  removeBackgroundClick: {
    campaign: EVENT.CATEGORY.STUDIO,
    action: EVENT.ACTION.REMOVE_BACKGROUND,
    label: EVENT.LABEL.REMOVE_BACKGROUND,
  },
  brandKitClick: {
    campaign: EVENT.CATEGORY.STUDIO,
    action: EVENT.ACTION.BRAND_KIT,
    label: EVENT.LABEL.BRAND_KIT,
  },
  projectsClick: {
    campaign: EVENT.CATEGORY.STUDIO,
    action: EVENT.ACTION.PROJECTS,
    label: EVENT.LABEL.PROJECTS,
  },
  openEditorClick: {
    campaign: EVENT.CATEGORY.STUDIO,
    action: EVENT.ACTION.OPEN_EDITOR,
    label: EVENT.LABEL.OPEN_EDITOR,
  },
  openTemplateClick: {
    campaign: EVENT.CATEGORY.STUDIO,
    action: EVENT.ACTION.OPEN_TEMPLATE,
    label: EVENT.LABEL.OPEN_TEMPLATE,
  },
  bannerProClick: {
    campaign: EVENT.CATEGORY.STUDIO,
    action: EVENT.ACTION.BANNER_PRO,
    label: EVENT.LABEL.BANNER_PRO,
  },
  showMoreTemplatesClick: {
    campaign: EVENT.CATEGORY.STUDIO,
    action: EVENT.ACTION.SHOW_MORE_TEMPLATES,
    label: EVENT.LABEL.SHOW_MORE_TEMPLATES,
  },
  createLogoClick: {
    campaign: EVENT.CATEGORY.STUDIO,
    action: EVENT.ACTION.CREATE_LOGO,
    label: EVENT.LABEL.CREATE_LOGO,
  },
  modalLogoButtonBackClick: {
    campaign: EVENT.CATEGORY.STUDIO,
    action: EVENT.ACTION.MODAL_LOGO_BUTTON_BACK,
    label: EVENT.LABEL.MODAL_LOGO_BUTTON_BACK,
  },
  goToStudioClick: {
    campaign: EVENT.CATEGORY.STUDIO,
    action: EVENT.ACTION.GO_TO_STUDIO,
    label: EVENT.LABEL.GO_TO_STUDIO,
  },
  downloadLogoClick: {
    campaign: EVENT.CATEGORY.STUDIO,
    action: EVENT.ACTION.DOWNLOAD_LOGO,
    label: EVENT.LABEL.DOWNLOAD_LOGO,
  },
  editLogoClick: {
    campaign: EVENT.CATEGORY.STUDIO,
    action: EVENT.ACTION.EDIT_LOGO,
    label: EVENT.LABEL.EDIT_LOGO,
  },
  generateMoreOptionsClick: {
    campaign: EVENT.CATEGORY.STUDIO,
    action: EVENT.ACTION.GENERATE_MORE_OPTIONS,
    label: EVENT.LABEL.GENERATE_MORE_OPTIONS,
  },
  createLogoManuallyClick: {
    campaign: EVENT.CATEGORY.STUDIO,
    action: EVENT.ACTION.CREATE_LOGO_MANUALLY,
    label: EVENT.LABEL.CREATE_LOGO_MANUALLY,
  },
  logoBuilderNoCreditsClick: {
    campaign: EVENT.CATEGORY.STUDIO,
    action: EVENT.ACTION.FEATURE_NO_CREDITS_CTA,
    label: EVENT.LABEL.LOGO_BUILDER_NO_CREDITS_CTA,
  },
  backgroundRemoverNoCreditsCta: {
    campaign: EVENT.CATEGORY.STUDIO,
    action: EVENT.ACTION.FEATURE_NO_CREDITS_CTA,
    label: EVENT.LABEL.BACKGROUND_REMOVER_NO_CREDITS_CTA,
  },
  backgroundRemoverStudioFreeCta: {
    campaign: EVENT.CATEGORY.STUDIO,
    action: EVENT.ACTION.STUDIO_FREE_CTA,
    label: EVENT.LABEL.BACKGROUND_REMOVER_STUDIO_FREE_CTA,
  },
  brandKitNoCreditsCta: {
    campaign: EVENT.CATEGORY.STUDIO,
    action: EVENT.ACTION.FEATURE_NO_CREDITS_CTA,
    label: EVENT.LABEL.BRAND_KIT_NO_CREDITS_CTA,
  },
  brandKitStudioFreeCta: {
    campaign: EVENT.CATEGORY.STUDIO,
    action: EVENT.ACTION.STUDIO_FREE_CTA,
    label: EVENT.LABEL.BRAND_KIT_STUDIO_FREE_CTA,
  },
};

const createSiteTopClick = () => {
  collect({
    event: 'gaEvent',
    ...events.createSiteTopClick,
  });
  collectTrackData(events.createSiteTopClick);
};

const createSiteBottomClick = () => {
  collect({
    event: 'gaEvent',
    ...events.createSiteBottomClick,
  });
  collectTrackData(events.createSiteBottomClick);
};

const logoCreatorClick = () => {
  collect({
    event: 'gaEvent',
    ...events.logoCreatorClick,
  });
  collectTrackData(events.logoCreatorClick);
};

const removeBackgroundClick = () => {
  collect({
    event: 'gaEvent',
    ...events.removeBackgroundClick,
  });
  collectTrackData(events.removeBackgroundClick);
};

const brandKitClick = () => {
  collect({
    event: 'gaEvent',
    ...events.brandKitClick,
  });
  collectTrackData(events.brandKitClick);
};

const projectsClick = () => {
  collect({
    event: 'gaEvent',
    ...events.projectsClick,
  });
  collectTrackData(events.projectsClick);
};

const openEditorClick = () => {
  collect({
    event: 'gaEvent',
    ...events.openEditorClick,
  });
  collectTrackData(events.openEditorClick);
};

const openTemplateClick = () => {
  collect({
    event: 'gaEvent',
    ...events.openTemplateClick,
  });
  collectTrackData(events.openTemplateClick);
};

const bannerProClick = () => {
  collect({
    event: 'gaEvent',
    ...events.bannerProClick,
  });
  collectTrackData(events.bannerProClick);
};

const showMoreTemplatesClick = () => {
  collect({
    event: 'gaEvent',
    ...events.showMoreTemplatesClick,
  });
  collectTrackData(events.showMoreTemplatesClick);
};

const createLogoClick = () => {
  collect({
    event: 'gaEvent',
    ...events.createLogoClick,
  });
  collectTrackData(events.createLogoClick);
};

const modalLogoButtonBackClick = () => {
  collect({
    event: 'gaEvent',
    ...events.modalLogoButtonBackClick,
  });
  collectTrackData(events.modalLogoButtonBackClick);
};

const goToStudioClick = () => {
  collect({
    event: 'gaEvent',
    ...events.goToStudioClick,
  });
  collectTrackData(events.goToStudioClick);
};

const downloadLogoClick = () => {
  collect({
    event: 'gaEvent',
    ...events.downloadLogoClick,
  });
  collectTrackData(events.downloadLogoClick);
};

const editLogoClick = () => {
  collect({
    event: 'gaEvent',
    ...events.editLogoClick,
  });
  collectTrackData(events.editLogoClick);
};

const generateMoreOptionsClick = () => {
  collect({
    event: 'gaEvent',
    ...events.generateMoreOptionsClick,
  });
  collectTrackData(events.generateMoreOptionsClick);
};

const createLogoManuallyClick = () => {
  collect({
    event: 'gaEvent',
    ...events.createLogoManuallyClick,
  });
  collectTrackData(events.createLogoManuallyClick);
};

const logoBuilderNoCreditsClick = () => {
  collect({
    event: 'gaEvent',
    ...events.logoBuilderNoCreditsClick,
  });
  collectTrackData(events.logoBuilderNoCreditsClick);
};

const backgroundRemoverNoCreditsCta = () => {
  collect({
    event: 'gaEvent',
    ...events.backgroundRemoverNoCreditsCta,
  });
  collectTrackData(events.backgroundRemoverNoCreditsCta);
};

const backgroundRemoverStudioFreeCta = () => {
  collect({
    event: 'gaEvent',
    ...events.backgroundRemoverStudioFreeCta,
  });
  collectTrackData(events.backgroundRemoverStudioFreeCta);
};

const brandKitNoCreditsCta = () => {
  collect({
    event: 'gaEvent',
    ...events.brandKitNoCreditsCta,
  });
  collectTrackData(events.brandKitNoCreditsCta);
};

const brandKitStudioFreeCta = () => {
  collect({
    event: 'gaEvent',
    ...events.brandKitStudioFreeCta,
  });
  collectTrackData(events.brandKitStudioFreeCta);
};

const analytics = {
  createSiteTopClick,
  createSiteBottomClick,
  logoCreatorClick,
  removeBackgroundClick,
  brandKitClick,
  projectsClick,
  openEditorClick,
  openTemplateClick,
  bannerProClick,
  showMoreTemplatesClick,
  createLogoClick,
  modalLogoButtonBackClick,
  goToStudioClick,
  downloadLogoClick,
  editLogoClick,
  generateMoreOptionsClick,
  createLogoManuallyClick,
  logoBuilderNoCreditsClick,
  backgroundRemoverNoCreditsCta,
  backgroundRemoverStudioFreeCta,
  brandKitNoCreditsCta,
  brandKitStudioFreeCta,
};

export default analytics;
